module.exports = __webpack_public_path__ + "img/ch08_07_蒙灰橱窗.9cd86322.jpg";